<template>
    <b-container fluid>
     
            <PortalNavbar show="true"></PortalNavbar>
        <section class="power_area row" style="margin-left:40px;">
<div class="container">
<!--<div class="tittle wow fadeInUp">
                <h2>POWER & DUTIES OF BOARD</h2>
               
            </div>-->
<div class="row power_row">
<div>
<div class="subtittle">
<h2 style="color:#ec5624;">POWER & DUTIES OF BOARD</h2>
</div><br/><br/>

<div class="col-md-12">
<ul>
<li>The Board shall be responsible for administering every Scheme and shall exercise such powers and perform and discharge such duties and functions as may be conferred on it by the Scheme.</li>
<li>The Board may take such measures as it may deem fit for administering the Scheme.</li>
<li>The Board shall submit to the State Government, as soon as may be, after the 1st day of April every year, and not later than the 21st day of October as annual report on the working of the Scheme during the preceding year ending on the 31st day of March of that year. Every report so received shall be laid, as soon as may  be after it is received before each house of the State legislature if it is in session,  or in the session immediately following the date of receipt of the report.</li>
<li>In exercise of the powers and performance and discharge of its duties and functions, the Board shall be bound by such directions as the State Government may, for reasons to be stated in writing give to it, from time to time.</li>
</ul>
</div>

</div>
</div>

</div>
</section>

</b-container>

</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>

.power_area .power_row {
padding-top:30px;
padding-bottom:30px;

  
}

.power_area .power_row ul {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
  padding-top: 18px;
  padding-bottom: 24px;
	
}

.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}

</style>



// WEBPACK FOOTER //
// src/components/Portal/Power.vue